import { FC, HTMLAttributes, ReactNode } from 'react';

import classes from './Value.module.scss';

interface ValueProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

const Value: FC<ValueProps> = ({ children, ...props }) => {
  return (
    <span className={classes.value} {...props}>
      {children}
    </span>
  );
};

export default Value;
